import { gql } from "@apollo/client";

// export const GET_VENDOR = gql(`
// query vendor($id: String!) {
//   vendor (where: {id: $id}){
//     id
//     name
//     description
//     image
//     type    
//   }
// }
// `);

export const UPDATE_VENDOR = gql(`
mutation updateVendor($vendor: UpdateVendorInputType!) {
  updateVendor(vendor: $vendor) {
    id
    name
    description
    image
    type    
    socials
    links
  }
}
`);

export const UPDATE_VENDOR_LINKS = gql(`
  mutation updateVendorLinks($vendor: UpdateVendorInputType!) {
    updateVendor(vendor: $vendor) {
      id
      name
      description
      image
      type    
      socials
      links  
      items
    }
  }
  `);

  export const UPDATE_VENDOR_ITEMS = gql(`
    mutation updateVendorItems($vendor: UpdateVendorInputType!) {
      updateVendor(vendor: $vendor) {
        id
        name
        description
        image
        type    
        socials
        links
        items  
      }
    }
    `);

export const CREATE_VENDOR = gql(`
mutation createVendor($name: String!, $description:String!, $type: String!) {
  createVendor(name: $name, description:$description, type: $type){
    id
    name
    description
    type
  }
}
`);

export const ADD_IMAGE = gql(`
mutation addImage($image: String!){
  addImage(image: $image)
}
`);

export const DELETE_VENDOR = gql(`mutation deleteVendor($vendorId:String!) {
  deleteVendor(vendorId: $vendorId){
    id
  }
}`);
